export default class Lead {
    constructor () {

        this.id = null
        this.first_name = ""
        this.surname = ""
        this.company = ""
        this.message = ""
        this.phone = ""
        this.mobile = ""
        this.status = "New"

        this.user_id = null
    }
}